import { GlButton } from '@gitlab/ui';
import { __, n__, sprintf } from '~/locale';
export default {
    name: 'WorkItemToggleClosedItems',
    components: {
        GlButton
    },
    props: {
        numberOfClosedItems: {
            type: Number,
            required: false,
            default: 0
        }
    },
    emits: [
        'show-closed'
    ],
    computed: {
        buttonText () {
            const itemText = n__('item', 'items', this.numberOfClosedItems);
            return sprintf(__('Show %{count} closed %{itemText}'), {
                count: this.numberOfClosedItems,
                itemText
            });
        }
    }
};
